import React from 'react'

import { Button, Segment } from 'goustouicomponents'
import PropTypes from 'prop-types'

const Portions = ({ numPortions, onNumPortionChange, trackNumPortionChange, orderId }) => {
  function segmentFor(segmentNumberOfPortions, segmentTitle) {
    return (
      <Segment
        key={segmentNumberOfPortions}
        fill={numPortions === segmentNumberOfPortions}
        onClick={() => {
          onNumPortionChange(segmentNumberOfPortions)
          trackNumPortionChange(segmentNumberOfPortions, orderId)
        }}
      >
        {segmentTitle}
      </Segment>
    )
  }

  const buttonSegments = [segmentFor(2, 'Regular box'), segmentFor(4, 'Large box')]

  return (
    <Button fill={false} width="full">
      {buttonSegments}
    </Button>
  )
}

Portions.propTypes = {
  numPortions: PropTypes.number.isRequired,
  onNumPortionChange: PropTypes.func.isRequired,
  trackNumPortionChange: PropTypes.func.isRequired,
  orderId: PropTypes.string.isRequired,
}

export { Portions }
